<template>
    <div class="foot-box">

        <div class="foot-top">
            <div class="wrap f-row-s-c h100">
                <div class="txts">{{ $t('PH.default') }}</div>
                <div class="txts">{{ $t('Foot1') }}</div>
            </div>
        </div>

        <div class="foot-bottom wrap f-row-b-c">
            <div class="l-foot f-row-s-c">
                <div class="list-box f-row-s-c f-w" style="margin-right:150px;">
                    <div class="list-item" v-for="(item, index) in oneList" :key="index" @click="goLinkLeft(item)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="list-box f-row-s-c f-w">
                    <div class="list-item" v-for="(item, index) in twoList" :key="index" @click="goLink(item)">
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div class="r-foot f-row-e-c">
                <div class="code-box f-col-c-c">
                    <img src="../../public/code_app.png" alt="">
                    <span>{{ $t('Foot11') }}</span>
                </div>
                <div class="code-box f-col-c-c">
                    <img src="../../public/code_gzh.png" alt="">
                    <span>{{ $t('Foot12') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $api from '@/api/api.js'
export default {
    name: "VhomeFoot",
    data() {
        return {
            oneList: [{
                id: '1',
                name: this.$t('Foot2'),
                url: ''
            }, {
                id: '2',
                name: this.$t('Foot3'),
                url: ''
            }, {
                id: '3',
                name: this.$t('Foot4'),
                url: ''
            }, {
                id: '4',
                name: this.$t('Foot5'),
                url: ''
            }, {
                id: '5',
                name: this.$t('Foot6'),
                url: ''
            }],
            twoList: [{
                id: '1',
                name: this.$t('Foot7'),
                url: '/taxi'
            }, {
                id: '2',
                name: this.$t('Foot8'),
                url: ''
            }, {
                id: '3',
                name: this.$t('Foot9'),
                url: '/travelList'
            },
            //  {
            //     id: '4',
            //     name: '接送机',
            //     url: '/transfer'
            // },
             {
                id: '5',
                name: this.$t('Foot10'),
                url: '/Bcar'
            },{
                id: '6',
                name: this.$t('Custom1'),
                url: '/customization'
            }],
        }
    },
    methods: {
        goLinkLeft(item) {
            if (item.id == 3) {
                this.$router.push({ path: '/agreement', query: { type: 2 } })
            } else if (item.id == 4) {
                this.$router.push({ path: '/agreement', query: { type: 1 } })
            }
        },
        goLink(item) {
            if(item.id == 2){
                //去汽车租赁
                this.getCarLink()
                return
            }
            this.$router.push(item.url, () => { }, () => { })
        },

        //获取汽车租赁链接
		getCarLink() {
			$api.platFormTextType({
				platFormType: 'COLLABORATIONLINK'
			}).then(res => {
				if (res.code == 200) {
					let url = res.data.context || ''
					window.open(url)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
    }
}
</script>

<style lang="scss" scoped>
.foot-box {
    min-height: 182px;
    background: #202020;
}

.foot-top {
    height: 64px;
    font-size: 20px;
    color: #dae0f3;
    border-bottom: 1px solid #2a2a2a;

    .txts {
        width: 344px;
    }
}

.foot-bottom {
    padding: 14px 0;

    .list-box {
        width: 194px;
    }

    .list-item {
        margin-right: 25px;
        line-height: 30px;
        font-size: 14px;
        color: #aeaeae;
        cursor: pointer;
    }

    .code-box {
        margin-left: 30px;

        img {
            width: 68px;
            height: 68px;
            background: #fff;
        }

        span {
            margin-top: 10px;
            font-size: 12px;
            color: #aeaeae;
        }
    }
}

.item-tit {
    margin-bottom: 30px;
    font-size: 18px;
    color: #333;

    .line {
        flex: 0 0 4px;
        margin-right: 8px;
        width: 4px;
        height: 18px;
        background: var(--theme-color);
    }
}

.imgs {
    flex: 0 0 222px;
    margin-right: 26px;
    width: 222px;
    height: 152px;

}

.infos {
    min-height: 152px;

    .info-con {
        line-height: 24px;
        font-size: 14px;
        color: #333;
    }

    .info-user {
        .user-img {
            margin-right: 8px;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            object-fit: cover;
        }

        .user-txt {
            .names {
                margin-bottom: 4px;
                font-size: 14px;
                color: #333;
            }

            .times {
                font-size: 12px;
                color: #666;
            }
        }
    }
}
</style>